// EXPLAIN: the reason use date-fns: https://github.com/Hacker0x01/react-datepicker/issues/1658
import cn from "date-fns/locale/zh-CN";
import moment from 'moment';
import { forwardRef, useEffect, useState } from "react";
import { Button, Col, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getWgycAllowedDate, getWgycAnyday } from "../../api/wgycApi";
import { dispatchAlertError } from "../../app/godispatch";
import Loading from "../component/Loading";
import RoleLayout from "../component/RoleLayout";
import WaterMark from "../component/WaterMark";
import './WGYCAnydayPage.css';

export default function WGYCAnydayPage() {
    document.title = '五癸运财-每日秘字水局'
    const [startDate, setStartDate] = useState();
    const [maxDate, setMaxDate] = useState(null);
    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <Button variant="outline-info" className="choosedate" onClick={onClick} ref={ref} disabled={loading}>
            {value ? value : '请点击选择'}
        </Button>
    ));
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState('')

    useEffect(() => {
        getWgycAllowedDate()
            .then((res) => {
                setMaxDate(moment(res.data).toDate())
            })
            .catch((err) => {
            })
    }, [])

    useEffect(() => {
        if (startDate) {
            setLoading(true)
            let param = moment(startDate).format('YYYY-MM-DD')
            getWgycAnyday(param)
                .then((res) => {
                    let content = res.data;
                    if (content.tjhc) {
                        setData({
                            ...content,
                            sec2: content.sec2.split('\n'),
                            sec3: content.sec3.split('\n'),
                            tjhcText: content.tjhcText.split('\n')
                        })
                    } else {
                        setData({
                            ...content,
                            sec2: content.sec2.split('\n'),
                            sec3: content.sec3.split('\n'),
                        })
                    }
                    setLoading(false)
                })
                .catch((err) => {
                    dispatchAlertError(err.message || '查询失败请稍后再试')
                    setData('')
                    setLoading(false)
                })
        }
    }, [startDate])

    return (
        <RoleLayout>
            <Container className="containerbox">
                <WaterMark>
                    <Row className='divide'></Row>
                    <Row >
                        <Col></Col>
                        <Col sm={8} md={6} className='d-flex justify-content-center align-items-center'>
                            <Form.Label className="fs-4 choosedatename ">查询日期(阳历)</Form.Label>
                            <DatePicker selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                minDate={moment().toDate()}
                                maxDate={maxDate}
                                selectsStart
                                dateFormat="yyyy-MM-dd"
                                locale={cn}
                                customInput={<ExampleCustomInput />}
                            />
                        </Col>
                        <Col></Col>
                    </Row>
                    <Row>
                        <Col className='d-flex justify-content-center align-items-center'>
                            <strong style={{ color: 'red' }}>每次布局保留1至3天，即可更换下一局</strong>
                        </Col>
                    </Row>
                    <Row className='divide'></Row>
                    {loading && <Loading />}
                    {!loading && data &&
                        <div className="resultBlock">
                            <Row >
                                <Col className='d-flex justify-content-center align-items-center'>
                                    {data.sec1}
                                </Col>
                            </Row>
                            <Row className='divide'></Row>
                            <Row >
                                <Col xs={5} className='d-flex justify-content-end'>
                                    {data.date}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={5} className='g-0 d-flex justify-content-end'>
                                    方位：
                                </Col>
                                <Col className="g-0">
                                    {data.location1}放一盆水
                                </Col>
                            </Row>
                            {!data.tjhc && data.location1 !== data.location2 &&
                                <Row>
                                    <Col xs={5} className='g-0 d-flex justify-content-end'>
                                    </Col>
                                    <Col className="g-0">
                                        {data.location2}放一盆水
                                    </Col>
                                </Row>
                            }
                            <Row>
                                <Col xs={5} className='g-0 d-flex justify-content-end'>
                                    时间：
                                </Col>
                                <Col className="g-0">
                                    {data.shichen}时 ({data.shichenString}点)
                                </Col>
                            </Row>
                            {!data.tjhc &&
                                <Row>
                                    <Col xs={5} className='g-0 d-flex justify-content-end'>
                                        💰左手秘字：
                                    </Col>
                                    <Col className="g-0">
                                        {data.mizi} ({data.miziColor}笔写)
                                    </Col>
                                </Row>
                            }
                            {data.tjhc &&
                                <>
                                    <Row className='divide'></Row>
                                    {data.tjhcText.map((line, index) =>
                                        <Row key={index}>
                                            <Col className='d-flex justify-content-center align-items-center'>
                                                {line}
                                            </Col>
                                        </Row>
                                    )}
                                </>
                            }
                            <Row className='divide'></Row>
                            <Row >
                                <Col>
                                    {data.sec2.map((line, index) => {
                                        return <Row key={index}>
                                            <Col className='d-flex justify-content-center align-items-center'>
                                                {line}
                                            </Col>
                                        </Row>
                                    })}
                                </Col>
                            </Row>
                            <Row className='divide'></Row>
                            <Row >
                                {data.sec3.map((line, index) => {
                                    return <Row key={index}>
                                        <Col className='d-flex justify-content-center align-items-center'>
                                            {line}
                                        </Col>
                                    </Row>
                                })}
                            </Row>
                            <Row className='divide'></Row>
                            <Row >
                                <Col className='d-flex justify-content-center align-items-center'>
                                    {data.sec4}
                                </Col>
                            </Row>
                        </div>
                    }
                </WaterMark>
            </Container >
        </RoleLayout >
    )
}